import { Modal } from "@mantine/core"
import { useForm, zodResolver } from "@mantine/form"
import { showNotification } from "@mantine/notifications"
import type { FAQ, Prisma } from "@tfg/db"
import { useTranslation } from "react-i18next"

import { FAQInputSchema } from "@tfg/types/schemas/faq"

import { FAQForm } from "./FAQForm"
import { useEditFAQMutation } from "./hooks"

type Props = {
  faq: FAQ
  onClose: () => void
}

export const FAQEditionModal = ({ faq, onClose }: Props) => {
  const { t } = useTranslation("admin")

  const {
    mutateAsync,
    isPending: isLoading,
    error,
  } = useEditFAQMutation(faq?.id, {
    onSuccess: () => {
      showNotification({
        color: "green",
        message: t("faq.modal.edit.success"),
      })
      form.reset()
      onClose()
    },
  })

  const form = useForm<Prisma.FAQUpdateInput>({
    initialValues: {
      lang: faq.lang,
      category: faq.category,
      question: faq.question,
      answer: faq.answer,
    },
    validate: zodResolver(FAQInputSchema),
  })

  return (
    <Modal title={t("faq.modal.edit.title")} opened onClose={onClose}>
      <FAQForm
        form={form}
        onSubmit={mutateAsync}
        isLoading={isLoading}
        error={error}
      />
    </Modal>
  )
}
